import { render } from "./SensorsMain.vue?vue&type=template&id=6bcf169a&scoped=true&ts=true"
import script from "./SensorsMain.vue?vue&type=script&lang=ts"
export * from "./SensorsMain.vue?vue&type=script&lang=ts"

import "./SensorsMain.vue?vue&type=style&index=0&id=6bcf169a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcf169a"]])

export default __exports__